import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logoutUser } from '../actions/authentication';
import withRouter from './WithRouter';
import { RiBuildingLine, RiCalendar2Line, RiCarLine, RiNewspaperLine, RiMap2Line, RiUserLine } from "react-icons/ri";


class Navbar extends Component {

    onLogout(e) {
        e.preventDefault();
        this.props.logoutUser(this.props);
    }

    render() {
        const {isAuthenticated, user} = this.props.auth;
        const authLinks = (
        <ul className="navbar-nav ml-auto">
            <li className="nav-item">
                <Link className="nav-link" to="/organizations">
                    <div className="icon">
                        <RiBuildingLine />
                    </div>
                    <div className="text">
                        Organizacje
                    </div>
                </Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/users">
                    <div className="icon">
                        <RiUserLine />
                    </div>
                    <div className="text">
                        Użytkownicy
                    </div>
                </Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/clients">
                    <div className="icon">
                        <RiCarLine />
                    </div>
                    <div className="text">
                        Klienci
                    </div>
                </Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/orders">
                    <div className="icon">
                        <RiNewspaperLine />
                    </div>
                    <div className="text">
                        Zlecenia
                    </div>
                </Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/calendar">
                    <div className="icon">
                        <RiCalendar2Line />
                    </div>
                    <div className="text">
                        Kalendarz
                    </div>
                </Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/map">
                    <div className="icon">
                        <RiMap2Line />
                    </div>
                    <div className="text">
                        Mapa
                    </div>
                </Link>
            </li>
        </ul>
        )
      const guestLinks = (
        <ul className="navbar-nav ml-auto">
            <li className="nav-item">
                <Link className="nav-link" to="/register">Rejestracja</Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/login">Zaloguj</Link>
            </li>
        </ul>
      )
        return(
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <Link className="navbar-brand" to="/">
                <div className="logo-wrapper">
                    <svg version="1.1" id="app_logo" x="0px" y="0px" viewBox="0 0 283.5 283.5">
                        <g>
                        <path className="st0" d="M137.4,226.7c-46.9-2.4-83-42.4-80.5-89.3l4-77.3c-4.8,5-11.7,8-19.2,7.6l-19.9-1c-2-0.1-3.9,0-5.7,0.3
                            C9,78.9,3.5,91.9,0,105.7c1.1,1.5,2.3,2.9,3.8,4.3l14.8,13.3c10.9,9.9,10.9,27,0,36.9L3.8,173.5c-1.5,1.3-2.7,2.8-3.8,4.3
                            c3.5,13.8,9,26.8,16.1,38.7c1.8,0.3,3.7,0.4,5.7,0.3l19.9-1c14.7-0.8,26.9,11.4,26.1,26.1l-1,19.9c-0.1,2,0,3.9,0.3,5.7
                            c11.9,7.1,24.9,12.6,38.7,16.1c1.5-1.1,2.9-2.3,4.3-3.8l13.3-14.8c9.9-10.9,27-10.9,36.9,0l13.3,14.8c1.1,1.2,2.3,2.3,3.5,3.2
                            l3.4-65.4C167.5,224,152.8,227.5,137.4,226.7z"/>
                        <path className="st0" d="M279.7,173.5l-14.8-13.3c-10.9-9.9-10.9-27,0-36.9l14.8-13.3c1.5-1.3,2.7-2.8,3.8-4.3
                            c-3.5-13.8-9-26.8-16.1-38.7c-1.8-0.3-3.7-0.4-5.7-0.3l-19.9,1c-14.7,0.8-26.9-11.4-26.1-26.1l1-19.9c0.1-2,0-3.9-0.3-5.7
                            C204.6,9,191.6,3.5,177.8,0c-1.5,1.1-2.9,2.3-4.3,3.8l-13.3,14.8c-9.9,10.9-27,10.9-36.9,0L110,3.8c-1.1-1.2-2.3-2.3-3.5-3.2
                            L103.1,66c12.9-6.6,27.6-10,43.1-9.2c46.9,2.4,83,42.4,80.5,89.3l-4,77.3c4.8-5,11.7-8,19.2-7.6l19.9,1c2,0.1,3.9,0,5.7-0.3
                            c7.1-11.9,12.6-24.9,16.1-38.7C282.4,176.3,281.2,174.8,279.7,173.5z"/>
                        <ellipse transform="matrix(0.9854 -0.1705 0.1705 0.9854 -22.0914 26.2426)" className="st0" cx="141.7" cy="141.7" rx="42.5" ry="42.5"/>
                        </g>
                    </svg>
                </div>
                
                
                </Link>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    {isAuthenticated ? authLinks : guestLinks}
                </div>
            </nav>
        )
    }
}
Navbar.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateToProps, { logoutUser })(withRouter(Navbar));
